import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image"
import AccuracyTextTooltip from "../../accuracy-text-with-tooltip";


const StyledHeroContainer = styled(Container)`

`
const Accuracy = () => {
    return (
        <StyledHeroContainer>
            <div className="row">
                <div className="col-sm-6">
                    <p><span className="fw-bolder fs-5">Accuracy</span></p>
                    <p>Clearout fetches pre-verified data after running through multiple checks with <AccuracyTextTooltip /> accuracy ensuring better performance from the outreach campaign. Whereas, Dropcontact has not disclosed the accuracy of the data pulled.</p>
                </div>
                <div className="col-sm-6 ">
                    <StaticImage src="../../../images/accuracy_co_vs_dropcontact.jpg" alt="Validate email address with Clearout's Email Verifier for accurate results and guaranteed email deliverability" placeholder="blurred" />
                </div>
            </div>

        </StyledHeroContainer>
    )
}

export default Accuracy;